// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 46%;
  flex-shrink: 0;
  flex-grow: 1;
}

.input-label {
  color: var(--secondary-text-color);
  /* New Typeface/Sub Heading 3 */
  font-family: "Medium Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 17.5px */
}

.required {
  color: #ef5054;
}

.input-field {
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  height: 44px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  line-height: 125%;
  color: var(--primary-text-color);
  font-family: "Medium Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  background-color: var(--primary-surface-color);
}
.input-field::placeholder {
  color: #94A0B3;
  font-family: "Medium Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%; /* 17.5px */
}
.input-field:focus {
  border: 2px solid #5095fc;
}
.input-field:disabled {
  background-color: #f5f5f5;
  color: #94a0b3;
  cursor: not-allowed;
  opacity: 0.6;
  border-color: #e0e0e0;
}

.input-field:focus-visible {
  border-color: #000; /* Replace with your primary color */
}

.input-error {
  border-color: #e34935;
}

.error-message {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: #e34935;
}`, "",{"version":3,"sources":["webpack://./src/components/Forms/Inputs/appInput.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,kCAAA;EAEA,+BAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAAF;AACE;EACE,cAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AACJ;AACE;EACE,yBAAA;AACJ;AAEE;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;AAAJ;;AAIA;EACE,kBAAA,EAAA,oCAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADF","sourcesContent":[".input-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  width: 46%;\n  flex-shrink: 0;\n  flex-grow: 1;\n}\n\n.input-label {\n  color: var(--secondary-text-color);\n\n  /* New Typeface/Sub Heading 3 */\n  font-family: 'Medium Sans';\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 125%; /* 17.5px */\n}\n\n.required {\n  color: #ef5054;\n}\n\n.input-field {\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  gap: 10px;\n  align-self: stretch;\n  height: 44px;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n  line-height: 125%;\n  color:  var(--primary-text-color);\n  font-family: 'Medium Sans';\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  background-color: var(--primary-surface-color);\n  &::placeholder {\n    color: #94A0B3;\n    font-family: 'Medium Sans';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 125%; /* 17.5px */\n  }\n  &:focus {\n    border: 2px solid  #5095fc;\n  }\n  \n  &:disabled {\n    background-color: #f5f5f5;\n    color: #94a0b3;\n    cursor: not-allowed;\n    opacity: 0.6;\n    border-color: #e0e0e0;\n  }\n}\n\n.input-field:focus-visible {\n  border-color: #000; /* Replace with your primary color */\n}\n\n.input-error {\n  border-color: #e34935;\n}\n\n.error-message {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  color: #e34935;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
